export default __webpack_public_path__ + "static/media/case.acbdba05.svg";